import React from 'react'
import InputForFloatAsText from '@EditorComponents/InputForFloatAsText'
import CheckboxV2 from '@EditorComponents/CheckboxV2'

import './Parameter.scss'

interface ParameterProps {
  readonly title: string
  readonly value: number
  readonly minValue: number
  readonly maxValue: number
  readonly useValue: boolean
  readonly unit?: string
  readonly isForSite?: boolean
  changeParameter(newValue: number): void
  changeUseParameter(newUseParameter: boolean): void
}

const Parameter: React.FC<ParameterProps> = props => {
  const {
    title,
    value,
    minValue,
    maxValue,
    unit,
    useValue,
    isForSite,
  } = props

  return (
    <div className={`Parameter Parameter__${unit ? unit.toLowerCase() : ''}`}>
      <div className="Parameter__left">
        <CheckboxV2
          checked={useValue}
          onChange={props.changeUseParameter}
        />
        <span className="Parameter__value">{title}</span>
      </div>
      <InputForFloatAsText
        min={minValue}
        max={maxValue}
        defaultValue={value}
        numberOfDigits={0}
        value={value}
        step={1}
        unit={unit}
        onChange={props.changeParameter}
        tooltip={`Enter a number between ${minValue} and ${maxValue}`}
        disabled={!useValue}
        isForSite={isForSite}
      />
    </div>
  )
}

export default Parameter
